/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VelkominRouteImport } from './routes/velkomin'
import { Route as TodosRouteImport } from './routes/todos'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GleymtLykilordRouteImport } from './routes/gleymt-lykilord'
import { Route as FarsimiRouteImport } from './routes/farsimi'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerkfaeriVaktaskraRouteImport } from './routes/verkfaeri.vaktaskra'
import { Route as VerkfaeriSpalikanOrkunotkunRouteImport } from './routes/verkfaeri.spalikan-orkunotkun'
import { Route as VerkfaeriMarkadurinnRouteImport } from './routes/verkfaeri.markadurinn'
import { Route as VerkfaeriAtomikaReiknivelRouteImport } from './routes/verkfaeri.atomika-reiknivel'
import { Route as VerkfaeriAtomikaMaelabordRouteImport } from './routes/verkfaeri.atomika-maelabord'
import { Route as VerkfaeriAtomikaHeimasidaRouteImport } from './routes/verkfaeri.atomika-heimasida'
import { Route as AdminStillingarRouteImport } from './routes/admin.stillingar'
import { Route as AdminNotendurRouteImport } from './routes/admin.notendur'
import { Route as VerkfaeriMarkadurinnIndexRouteImport } from './routes/verkfaeri.markadurinn.index'
import { Route as VerkfaeriMarkadurinnFyrirtaekiKennitalaRouteImport } from './routes/verkfaeri.markadurinn.fyrirtaeki.$kennitala'

const VelkominRoute = VelkominRouteImport.update({
  id: '/velkomin',
  path: '/velkomin',
  getParentRoute: () => rootRouteImport,
} as any)
const TodosRoute = TodosRouteImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GleymtLykilordRoute = GleymtLykilordRouteImport.update({
  id: '/gleymt-lykilord',
  path: '/gleymt-lykilord',
  getParentRoute: () => rootRouteImport,
} as any)
const FarsimiRoute = FarsimiRouteImport.update({
  id: '/farsimi',
  path: '/farsimi',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkfaeriVaktaskraRoute = VerkfaeriVaktaskraRouteImport.update({
  id: '/verkfaeri/vaktaskra',
  path: '/verkfaeri/vaktaskra',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkfaeriSpalikanOrkunotkunRoute =
  VerkfaeriSpalikanOrkunotkunRouteImport.update({
    id: '/verkfaeri/spalikan-orkunotkun',
    path: '/verkfaeri/spalikan-orkunotkun',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerkfaeriMarkadurinnRoute = VerkfaeriMarkadurinnRouteImport.update({
  id: '/verkfaeri/markadurinn',
  path: '/verkfaeri/markadurinn',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkfaeriAtomikaReiknivelRoute =
  VerkfaeriAtomikaReiknivelRouteImport.update({
    id: '/verkfaeri/atomika-reiknivel',
    path: '/verkfaeri/atomika-reiknivel',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerkfaeriAtomikaMaelabordRoute =
  VerkfaeriAtomikaMaelabordRouteImport.update({
    id: '/verkfaeri/atomika-maelabord',
    path: '/verkfaeri/atomika-maelabord',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerkfaeriAtomikaHeimasidaRoute =
  VerkfaeriAtomikaHeimasidaRouteImport.update({
    id: '/verkfaeri/atomika-heimasida',
    path: '/verkfaeri/atomika-heimasida',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminStillingarRoute = AdminStillingarRouteImport.update({
  id: '/admin/stillingar',
  path: '/admin/stillingar',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNotendurRoute = AdminNotendurRouteImport.update({
  id: '/admin/notendur',
  path: '/admin/notendur',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkfaeriMarkadurinnIndexRoute =
  VerkfaeriMarkadurinnIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => VerkfaeriMarkadurinnRoute,
  } as any)
const VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute =
  VerkfaeriMarkadurinnFyrirtaekiKennitalaRouteImport.update({
    id: '/fyrirtaeki/$kennitala',
    path: '/fyrirtaeki/$kennitala',
    getParentRoute: () => VerkfaeriMarkadurinnRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/farsimi': typeof FarsimiRoute
  '/gleymt-lykilord': typeof GleymtLykilordRoute
  '/login': typeof LoginRoute
  '/todos': typeof TodosRoute
  '/velkomin': typeof VelkominRoute
  '/admin/notendur': typeof AdminNotendurRoute
  '/admin/stillingar': typeof AdminStillingarRoute
  '/verkfaeri/atomika-heimasida': typeof VerkfaeriAtomikaHeimasidaRoute
  '/verkfaeri/atomika-maelabord': typeof VerkfaeriAtomikaMaelabordRoute
  '/verkfaeri/atomika-reiknivel': typeof VerkfaeriAtomikaReiknivelRoute
  '/verkfaeri/markadurinn': typeof VerkfaeriMarkadurinnRouteWithChildren
  '/verkfaeri/spalikan-orkunotkun': typeof VerkfaeriSpalikanOrkunotkunRoute
  '/verkfaeri/vaktaskra': typeof VerkfaeriVaktaskraRoute
  '/verkfaeri/markadurinn/': typeof VerkfaeriMarkadurinnIndexRoute
  '/verkfaeri/markadurinn/fyrirtaeki/$kennitala': typeof VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/farsimi': typeof FarsimiRoute
  '/gleymt-lykilord': typeof GleymtLykilordRoute
  '/login': typeof LoginRoute
  '/todos': typeof TodosRoute
  '/velkomin': typeof VelkominRoute
  '/admin/notendur': typeof AdminNotendurRoute
  '/admin/stillingar': typeof AdminStillingarRoute
  '/verkfaeri/atomika-heimasida': typeof VerkfaeriAtomikaHeimasidaRoute
  '/verkfaeri/atomika-maelabord': typeof VerkfaeriAtomikaMaelabordRoute
  '/verkfaeri/atomika-reiknivel': typeof VerkfaeriAtomikaReiknivelRoute
  '/verkfaeri/spalikan-orkunotkun': typeof VerkfaeriSpalikanOrkunotkunRoute
  '/verkfaeri/vaktaskra': typeof VerkfaeriVaktaskraRoute
  '/verkfaeri/markadurinn': typeof VerkfaeriMarkadurinnIndexRoute
  '/verkfaeri/markadurinn/fyrirtaeki/$kennitala': typeof VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/farsimi': typeof FarsimiRoute
  '/gleymt-lykilord': typeof GleymtLykilordRoute
  '/login': typeof LoginRoute
  '/todos': typeof TodosRoute
  '/velkomin': typeof VelkominRoute
  '/admin/notendur': typeof AdminNotendurRoute
  '/admin/stillingar': typeof AdminStillingarRoute
  '/verkfaeri/atomika-heimasida': typeof VerkfaeriAtomikaHeimasidaRoute
  '/verkfaeri/atomika-maelabord': typeof VerkfaeriAtomikaMaelabordRoute
  '/verkfaeri/atomika-reiknivel': typeof VerkfaeriAtomikaReiknivelRoute
  '/verkfaeri/markadurinn': typeof VerkfaeriMarkadurinnRouteWithChildren
  '/verkfaeri/spalikan-orkunotkun': typeof VerkfaeriSpalikanOrkunotkunRoute
  '/verkfaeri/vaktaskra': typeof VerkfaeriVaktaskraRoute
  '/verkfaeri/markadurinn/': typeof VerkfaeriMarkadurinnIndexRoute
  '/verkfaeri/markadurinn/fyrirtaeki/$kennitala': typeof VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/farsimi'
    | '/gleymt-lykilord'
    | '/login'
    | '/todos'
    | '/velkomin'
    | '/admin/notendur'
    | '/admin/stillingar'
    | '/verkfaeri/atomika-heimasida'
    | '/verkfaeri/atomika-maelabord'
    | '/verkfaeri/atomika-reiknivel'
    | '/verkfaeri/markadurinn'
    | '/verkfaeri/spalikan-orkunotkun'
    | '/verkfaeri/vaktaskra'
    | '/verkfaeri/markadurinn/'
    | '/verkfaeri/markadurinn/fyrirtaeki/$kennitala'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/farsimi'
    | '/gleymt-lykilord'
    | '/login'
    | '/todos'
    | '/velkomin'
    | '/admin/notendur'
    | '/admin/stillingar'
    | '/verkfaeri/atomika-heimasida'
    | '/verkfaeri/atomika-maelabord'
    | '/verkfaeri/atomika-reiknivel'
    | '/verkfaeri/spalikan-orkunotkun'
    | '/verkfaeri/vaktaskra'
    | '/verkfaeri/markadurinn'
    | '/verkfaeri/markadurinn/fyrirtaeki/$kennitala'
  id:
    | '__root__'
    | '/'
    | '/farsimi'
    | '/gleymt-lykilord'
    | '/login'
    | '/todos'
    | '/velkomin'
    | '/admin/notendur'
    | '/admin/stillingar'
    | '/verkfaeri/atomika-heimasida'
    | '/verkfaeri/atomika-maelabord'
    | '/verkfaeri/atomika-reiknivel'
    | '/verkfaeri/markadurinn'
    | '/verkfaeri/spalikan-orkunotkun'
    | '/verkfaeri/vaktaskra'
    | '/verkfaeri/markadurinn/'
    | '/verkfaeri/markadurinn/fyrirtaeki/$kennitala'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FarsimiRoute: typeof FarsimiRoute
  GleymtLykilordRoute: typeof GleymtLykilordRoute
  LoginRoute: typeof LoginRoute
  TodosRoute: typeof TodosRoute
  VelkominRoute: typeof VelkominRoute
  AdminNotendurRoute: typeof AdminNotendurRoute
  AdminStillingarRoute: typeof AdminStillingarRoute
  VerkfaeriAtomikaHeimasidaRoute: typeof VerkfaeriAtomikaHeimasidaRoute
  VerkfaeriAtomikaMaelabordRoute: typeof VerkfaeriAtomikaMaelabordRoute
  VerkfaeriAtomikaReiknivelRoute: typeof VerkfaeriAtomikaReiknivelRoute
  VerkfaeriMarkadurinnRoute: typeof VerkfaeriMarkadurinnRouteWithChildren
  VerkfaeriSpalikanOrkunotkunRoute: typeof VerkfaeriSpalikanOrkunotkunRoute
  VerkfaeriVaktaskraRoute: typeof VerkfaeriVaktaskraRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/velkomin': {
      id: '/velkomin'
      path: '/velkomin'
      fullPath: '/velkomin'
      preLoaderRoute: typeof VelkominRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/todos': {
      id: '/todos'
      path: '/todos'
      fullPath: '/todos'
      preLoaderRoute: typeof TodosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gleymt-lykilord': {
      id: '/gleymt-lykilord'
      path: '/gleymt-lykilord'
      fullPath: '/gleymt-lykilord'
      preLoaderRoute: typeof GleymtLykilordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/farsimi': {
      id: '/farsimi'
      path: '/farsimi'
      fullPath: '/farsimi'
      preLoaderRoute: typeof FarsimiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/vaktaskra': {
      id: '/verkfaeri/vaktaskra'
      path: '/verkfaeri/vaktaskra'
      fullPath: '/verkfaeri/vaktaskra'
      preLoaderRoute: typeof VerkfaeriVaktaskraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/spalikan-orkunotkun': {
      id: '/verkfaeri/spalikan-orkunotkun'
      path: '/verkfaeri/spalikan-orkunotkun'
      fullPath: '/verkfaeri/spalikan-orkunotkun'
      preLoaderRoute: typeof VerkfaeriSpalikanOrkunotkunRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/markadurinn': {
      id: '/verkfaeri/markadurinn'
      path: '/verkfaeri/markadurinn'
      fullPath: '/verkfaeri/markadurinn'
      preLoaderRoute: typeof VerkfaeriMarkadurinnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/atomika-reiknivel': {
      id: '/verkfaeri/atomika-reiknivel'
      path: '/verkfaeri/atomika-reiknivel'
      fullPath: '/verkfaeri/atomika-reiknivel'
      preLoaderRoute: typeof VerkfaeriAtomikaReiknivelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/atomika-maelabord': {
      id: '/verkfaeri/atomika-maelabord'
      path: '/verkfaeri/atomika-maelabord'
      fullPath: '/verkfaeri/atomika-maelabord'
      preLoaderRoute: typeof VerkfaeriAtomikaMaelabordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/atomika-heimasida': {
      id: '/verkfaeri/atomika-heimasida'
      path: '/verkfaeri/atomika-heimasida'
      fullPath: '/verkfaeri/atomika-heimasida'
      preLoaderRoute: typeof VerkfaeriAtomikaHeimasidaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/stillingar': {
      id: '/admin/stillingar'
      path: '/admin/stillingar'
      fullPath: '/admin/stillingar'
      preLoaderRoute: typeof AdminStillingarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/notendur': {
      id: '/admin/notendur'
      path: '/admin/notendur'
      fullPath: '/admin/notendur'
      preLoaderRoute: typeof AdminNotendurRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/markadurinn/': {
      id: '/verkfaeri/markadurinn/'
      path: '/'
      fullPath: '/verkfaeri/markadurinn/'
      preLoaderRoute: typeof VerkfaeriMarkadurinnIndexRouteImport
      parentRoute: typeof VerkfaeriMarkadurinnRoute
    }
    '/verkfaeri/markadurinn/fyrirtaeki/$kennitala': {
      id: '/verkfaeri/markadurinn/fyrirtaeki/$kennitala'
      path: '/fyrirtaeki/$kennitala'
      fullPath: '/verkfaeri/markadurinn/fyrirtaeki/$kennitala'
      preLoaderRoute: typeof VerkfaeriMarkadurinnFyrirtaekiKennitalaRouteImport
      parentRoute: typeof VerkfaeriMarkadurinnRoute
    }
  }
}

interface VerkfaeriMarkadurinnRouteChildren {
  VerkfaeriMarkadurinnIndexRoute: typeof VerkfaeriMarkadurinnIndexRoute
  VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute: typeof VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute
}

const VerkfaeriMarkadurinnRouteChildren: VerkfaeriMarkadurinnRouteChildren = {
  VerkfaeriMarkadurinnIndexRoute: VerkfaeriMarkadurinnIndexRoute,
  VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute:
    VerkfaeriMarkadurinnFyrirtaekiKennitalaRoute,
}

const VerkfaeriMarkadurinnRouteWithChildren =
  VerkfaeriMarkadurinnRoute._addFileChildren(VerkfaeriMarkadurinnRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FarsimiRoute: FarsimiRoute,
  GleymtLykilordRoute: GleymtLykilordRoute,
  LoginRoute: LoginRoute,
  TodosRoute: TodosRoute,
  VelkominRoute: VelkominRoute,
  AdminNotendurRoute: AdminNotendurRoute,
  AdminStillingarRoute: AdminStillingarRoute,
  VerkfaeriAtomikaHeimasidaRoute: VerkfaeriAtomikaHeimasidaRoute,
  VerkfaeriAtomikaMaelabordRoute: VerkfaeriAtomikaMaelabordRoute,
  VerkfaeriAtomikaReiknivelRoute: VerkfaeriAtomikaReiknivelRoute,
  VerkfaeriMarkadurinnRoute: VerkfaeriMarkadurinnRouteWithChildren,
  VerkfaeriSpalikanOrkunotkunRoute: VerkfaeriSpalikanOrkunotkunRoute,
  VerkfaeriVaktaskraRoute: VerkfaeriVaktaskraRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
